export function convertTagKeyToMetricsGatewayDimensionKey(tagKey) {
  switch (tagKey) {
    case 'assetName':
      return 'OBJECT_NAME'
    case 'lastCDN':
      return 'CDN';
    default: // tagMap case
      return tagKey;
  }
}